import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/themetwo/arr.png'
import _imports_1 from '@/assets/themetwo/base.png'
import _imports_2 from '@/assets/bonus/weikaishi_tu.png'
import _imports_3 from '@/assets/bonus/smactv2_btn_expire.png'
import _imports_4 from '@/assets/bonus/smactv2_btn_notstart.png'


const _hoisted_1 = { class: "bonus_container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "day_row" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "day_card" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "date_text" }
const _hoisted_8 = { style: {"padding":"15px","margin-top":"-10%"} }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "date_details" }
const _hoisted_11 = {
  key: 0,
  class: "tabel_container"
}
const _hoisted_12 = { style: {"color":"#ffcb52","font-size":"14px"} }
const _hoisted_13 = {
  key: 1,
  class: "bottom_text"
}

import { formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';
import { ref, onMounted, watch } from 'vue';
import { BonusData, calculateValue, MYSTERIO_IMG_THEME_TWO } from '@/view/bonus/supportScript';
import CustomHeader from '../components/common/customHeader.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusView',
  props: {
    dataSet: {}
  },
  emits: ['pickMisteryGift', 'selectTab'],
  setup(__props: any, { emit: __emit }) {

const mysterioImages = ref(MYSTERIO_IMG_THEME_TWO)
const selectedTabIndex = ref(0)
const swipeName = ref('swipe-left') 
const props = __props

const emits = __emit

const pickMisteryGift = (activeStatus: number) => {
    emits('pickMisteryGift', activeStatus)
}

const selectTab = (item: any, index: number) => {
     if (index > selectedTabIndex.value) {
        swipeName.value = 'swipe-left'
    } else if (index < selectedTabIndex.value) {
        swipeName.value = 'swipe-right'
    }
    selectedTabIndex.value = index
    emits('selectTab', item)
}

function syncSelectedIndex() {
    if (!props.dataSet || !props.dataSet.dayList || !props.dataSet.selectedTab) return
    const idx = props.dataSet.dayList.findIndex(item => item.reward_day === props.dataSet.selectedTab.reward_day)
    if (idx >= 0) selectedTabIndex.value = idx
}

onMounted(() => {
    syncSelectedIndex()
})

watch(() => props.dataSet, (val) => {
    if (val) syncSelectedIndex()
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('bonus.mysterybonus')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.dataSet.bannerIcon,
        alt: ""
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.dayList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => (selectTab(item, index))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "content",
                style: _normalizeStyle({ background: item.reward_day == _ctx.dataSet.selectedTab.reward_day ? 'linear-gradient(180deg, #ff3d9e, #fd66b1)' : '' })
              }, [
                _createElementVNode("img", {
                  src: mysterioImages.value[index].img,
                  alt: "",
                  width: "50%"
                }, null, 8, _hoisted_6),
                _createElementVNode("div", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.travel')) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(item.reward_day), 1)
                ])
              ], 4)
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_Transition, { name: swipeName.value }, {
        default: _withCtx(() => [
          (_ctx.dataSet.selectedTab)
            ? (_openBlock(), _createElementBlock("div", {
                class: "details_card",
                key: selectedTabIndex.value
              }, [
                _createVNode(_component_van_row, { class: "details_content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_col, { span: "24" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_row, { class: "topCard" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_van_col, {
                              span: "12",
                              class: "label_text"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('bonus.registrationTime')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_van_col, {
                              span: "12",
                              class: "value_text"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(formatUnixTimestamp)(_ctx.dataSet.mysteryDataConfig?.config?.user_join_date)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_van_col, {
                              span: "15",
                              class: "label_text"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('bonus.totalDeposit')) + " ", 1),
                                _createElementVNode("span", null, _toDisplayString(_ctx.dataSet.selectedTab?.reward_day), 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.days')) + ":", 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_van_col, {
                              span: "9",
                              class: "value_text",
                              style: {"color":"#ffcb52"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("R$" + _toDisplayString(_unref(formatCurrency)(_ctx.dataSet.selectedTab?.reward_data?.rechargeCoin || 0)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_col, {
                      span: 2,
                      class: "arrowImage",
                      style: {"transform":"rotate(180deg)"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _imports_0,
                          style: {"height":"30px","width":"30px"},
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (selectTab((selectedTabIndex.value - 1) < 0 ? _ctx.dataSet.dayList[_ctx.dataSet.dayList.length - 1] : _ctx.dataSet.dayList[selectedTabIndex.value - 1], (selectedTabIndex.value - 1) < 0 ? _ctx.dataSet.dayList.length - 1 : selectedTabIndex.value - 1)))
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_col, {
                      span: 20,
                      class: "middleImage"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: mysterioImages.value[selectedTabIndex.value].img,
                          style: {"height":"150px","width":"150px","z-index":"1"},
                          alt: "",
                          width: "100%"
                        }, null, 8, _hoisted_9),
                        _cache[3] || (_cache[3] = _createElementVNode("img", {
                          src: _imports_1,
                          class: "baseImg",
                          style: {"height":"72px","width":"222px"},
                          alt: "",
                          width: "100%"
                        }, null, -1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_col, {
                      span: 2,
                      class: "arrowImage"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _imports_0,
                          style: {"height":"30px","width":"30px"},
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (selectTab((selectedTabIndex.value + 1) > _ctx.dataSet.dayList.length - 1 ? _ctx.dataSet.dayList[0] : _ctx.dataSet.dayList[selectedTabIndex.value + 1], (selectedTabIndex.value + 1) > _ctx.dataSet.dayList.length - 1 ? 0 : selectedTabIndex.value + 1)))
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_col, { span: "24" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_row, { class: "middleCard" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_van_col, {
                              span: "24",
                              class: "text_1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('bonus.claimTime')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_van_col, { span: "24" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(formatUnixTimestamp)(_ctx.dataSet.selectedTab?.reward_data?.rewardTime)), 1)
                              ]),
                              _: 1
                            }),
                            (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0)
                              ? (_openBlock(), _createBlock(_component_van_col, {
                                  key: 0,
                                  span: "24",
                                  class: "misterio_text"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('bonus.mysterybonus')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0 || _ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && _ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
                              ? (_openBlock(), _createBlock(_component_van_col, {
                                  key: 1,
                                  span: "24",
                                  class: "amount"
                                }, {
                                  default: _withCtx(() => [
                                    _cache[4] || (_cache[4] = _createTextVNode("R$ ")),
                                    _createElementVNode("span", {
                                      style: _normalizeStyle({ color: _ctx.dataSet.selectedTab?.reward_data?.rewardCoin > 0 ? '#ffcb52' : '#ffcb52' })
                                    }, _toDisplayString(_unref(formatCurrency)(_ctx.dataSet.selectedTab?.reward_data?.rewardCoin || 0)), 5)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 2 ||  (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && !_ctx.dataSet.selectedTab?.reward_data?.rewardCoin))
                              ? (_openBlock(), _createBlock(_component_van_col, {
                                  key: 2,
                                  span: "24",
                                  class: "misterio"
                                }, {
                                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                                    _createElementVNode("img", {
                                      src: _imports_2,
                                      alt: ""
                                    }, null, -1)
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0 && !_ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
                      ? (_openBlock(), _createBlock(_component_van_col, {
                          key: 0,
                          span: "24",
                          class: "start_img"
                        }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createElementVNode("img", {
                              src: _imports_3,
                              alt: ""
                            }, null, -1)
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0 && _ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
                      ? (_openBlock(), _createBlock(_component_van_col, {
                          key: 1,
                          span: "24",
                          class: "statusBar",
                          style: {"color":"#66d329"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('activityStatus.completed')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && !_ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
                      ? (_openBlock(), _createBlock(_component_van_col, {
                          key: 2,
                          span: "24",
                          class: "start_img2"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _imports_4,
                              alt: "",
                              class: _normalizeClass({ 'pop-animate': _ctx.dataSet.isPopping }),
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (pickMisteryGift(_ctx.dataSet.selectedTab?.reward_data?.activeStatus)))
                            }, null, 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && _ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
                      ? (_openBlock(), _createBlock(_component_van_col, {
                          key: 3,
                          span: "24",
                          class: "statusBar",
                          style: {"color":"#66d329"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('activityStatus.completed')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 2)
                      ? (_openBlock(), _createBlock(_component_van_col, {
                          key: 4,
                          span: "24",
                          class: "statusBar",
                          style: {"color":"#f8d8a7"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('rewards.notActivated')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["name"])
    ]),
    (_ctx.dataSet.selectedTab)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_van_row, { class: "tabel_hed" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "11",
                class: "head_alignemnet"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('bonus.depostiScope')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "2",
                class: "head_alignemnet"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createElementVNode("div", { class: "line" }, null, -1)
                ])),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "11",
                class: "head_alignemnet"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('bonus.mysterybonus')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.selectedTab?.reward_data?.reward_day_data, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_row, {
              class: "tabel_row",
              key: index,
              style: _normalizeStyle({
                backgroundColor: '#312734',
                borderRadius: index === _ctx.dataSet.selectedTab?.reward_data?.reward_day_data.length - 1 ? '0px 0px 10px 10px' : ''
            })
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _cache[8] || (_cache[8] = _createTextVNode("R$ ")),
                    _createElementVNode("span", null, _toDisplayString(item.recharge_min < 0 ? '\u221E' : _unref(formatCurrency)(_unref(calculateValue)(item.recharge_min))) + " ~ " + _toDisplayString(item.recharge_max < 0 ? '\u221E' : _unref(formatCurrency)(_unref(calculateValue)(item.recharge_max))), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "head_alignemnet currencyText"
                }, {
                  default: _withCtx(() => [
                    _cache[9] || (_cache[9] = _createTextVNode("R$ ")),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(item.show_reward_min < 0 ? '\u221E' :
                    _unref(formatCurrency)(_unref(calculateValue)(item.show_reward_min))) + " ~ " + _toDisplayString(item.show_reward_max < 0 ? '\u221E'
                            : _unref(formatCurrency)(_unref(calculateValue)(item.show_reward_max))), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["style"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.dataSet.activityInfo.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_van_row, { style: {"padding-bottom":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "24",
                class: "title"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('common.activityTitle')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activityInfo, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "line_text",
              key: index
            }, _toDisplayString(item), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})